export * from './apollo-fetch';
//# sourceMappingURL=index.js.map